var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.666992 3.87258C0.666992 1.83008 2.35886 0.166748 4.43744 0.166748H8.57169C10.646 0.166748 12.3337 1.82508 12.3337 3.86425V13.1276C12.3337 15.1709 10.6418 16.8334 8.56237 16.8334H4.4298C2.35462 16.8334 0.666992 15.1751 0.666992 13.1359V12.3526V3.87258Z",
    fill: "#8395A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.149 8.04579L14.7775 5.62162C14.5324 5.37162 14.138 5.37162 13.8937 5.62329C13.6502 5.87495 13.651 6.28079 13.8953 6.53079L15.1947 7.85829H13.9489H6.95696C6.61203 7.85829 6.33203 8.14579 6.33203 8.49995C6.33203 8.85495 6.61203 9.14162 6.95696 9.14162H15.1947L13.8953 10.4691C13.651 10.7191 13.6502 11.125 13.8937 11.3766C14.0162 11.5025 14.1761 11.5658 14.3368 11.5658C14.4959 11.5658 14.6558 11.5025 14.7775 11.3783L17.149 8.95495C17.2667 8.83412 17.3333 8.67079 17.3333 8.49995C17.3333 8.32995 17.2667 8.16662 17.149 8.04579Z",
    fill: "#8395A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4fef3c532eb8d02bfa5a6afd9455a6f6.svg";
export { ForwardRef as ReactComponent };